import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// ✅ Fetch All Blood Groups
export const fetchIdentityTypeCard = createAsyncThunk(
	"identityTypeCard/fetchAll",
	async (_, { rejectWithValue }) => {
		try {
			const response = await api.get(`/v1/IdentityCardType`);
			return response.data?.data || response.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message);
		}
	},
);

const IdentityTypeCardSlice = createSlice({
	name: "identityCardType",
	initialState: {
		data: [],
		selected: null,
		loading: false,
		error: null,
		successMessage: null,
	},
	reducers: {
		clearSelectedIdentityCardType: (state) => {
			state.selected = null;
		},
		clearMessages: (state) => {
			state.successMessage = null;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder

			//  Fetch All Blood Groups
			.addCase(fetchIdentityTypeCard.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchIdentityTypeCard.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload;
			})
			.addCase(fetchIdentityTypeCard.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { clearSelectedBloodGroup, clearMessages } =
	IdentityTypeCardSlice.actions;

export default IdentityTypeCardSlice.reducer;
